import { get } from '.';

export function GetAppointmentDashboardAppointments(options = {}) {
    return get<any>("/app/api/appointment_dashboard/appointments", options);
}

export function GetAppointmentDashboardCalendar(options = {}) {
    return get<any>("/app/api/appointment_dashboard/calendar", options)
}